<template>
  <section class="create-form">
    <header>
      <h1>New Form</h1>
    </header>
    <p-create-form :is-request-pending="isCreateRequestPending" :is-request-failed="isCreateRequestFailed" @submit="create" />
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditForm from './_CreateOrEdit';

export default {
  components: {
    'p-create-form': CreateOrEditForm
  },
  computed: {
    ...mapState({
      isCreateRequestPending: s => s.forms.isCreateRequestPending,
      isCreateRequestFailed: s => s.forms.isCreateRequestFailed
    })
  },
  methods: {
    async create(data) {
      try {
        await this.$store.dispatch('forms/create', data);

        this.$toast.success({
          title: 'Create completed',
          message: `Form was created.`
        });
        this.$router.push({ path: `/forms/` });
      } catch (e) {
        const { message } = JSON.parse(await e.response.text());
        this.$toast.error({
          title: 'Create failed',
          message: message || `Please, try again later or contact our development team.`
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.create-form {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }
}
</style>
